import React from 'react'
import LeaveApplications from '../../../component/Admin/LeaveApplications'

const LeaveApplicationsScreen = () => {
  return (
    <div><LeaveApplications /></div>
  )
}

export default LeaveApplicationsScreen